<template>
    <!-- display customer account -->
    <div class="container-fluid">
        <div class="row my-3">
            <div class="col-sm-4 col-9">
                <h4>Orders</h4>
            </div>
            <div class="col-sm-8 col-3 text-right">
                <router-link :to="{ name: 'customer-account' }" class="btn btn-outline-dark btn-sm">
                    <i class="fas fa-user-circle"></i> 
                    <span class="d-none d-sm-inline"> 
                        <span v-if="user && user.firstName" class="add-ellipsis"> {{user.firstName | capitalize}}!</span> 
                        <span v-else>Account</span>
                    </span>
                </router-link>
            </div>
        </div>

        <div v-if="theOrders" class="row mb-5">
            <div class="col-12">
                <div class="table-responsive bg-light anewitem-shipping-table">
                    <table class="table table-hover">
                        <thead class="bg-silver">
                            <tr class="font-weight-bold">
                                <td>ORDER</td>
                                <td>STATUS</td>
                                <td>PAYMENT</td>
                                <td>METHOD</td>
                                <td class="text-center">ITEMS</td>
                                <td class="text-center">TOTAL</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(order, x) in theOrders" :key="x">
                                <td>
                                    <router-link :to="{ name: 'customer-order', params: { orderNum: `${order.orderNumber}` } }">
                                        <span class="text-dark-green font-weight-bold">#{{order.orderNumber}}</span>
                                        <br><small>&nbsp; {{order.joined | moment("MMM-D-YY")}}</small>
                                    </router-link>
                                </td>
                                <td>{{order.status | capitalize}}</td>
                                <td>{{order.paid ? "Paid" : "Pending"}}</td>
                                <td>{{order.paymentMethod | capitalize}}</td>
                                <td class="text-center">{{order.itemsCount}}</td>
                                <td class="text-center">{{order.currency.toUpperCase()}} {{order.amount * order.exchangeRate | money}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { webpageTitle } from '@/store/dry'

import LayoutGeneral from '@/layouts/General.vue'

export default {
    name: "CustomerOrders",
    computed: {
        ...mapGetters(['user', 'setOrders']),
        theOrders() {
            if(this.setOrders) {
                return this.setOrders
            }
            return false
        },
    },
    created() {
        webpageTitle(`My orders`)
        this.$emit('update:layout', LayoutGeneral);
    }
}
</script>